import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  useColorModeValue,
  CloseButton,
  Box,
} from "@chakra-ui/react";
import { useState } from "react";
import { useNavigate } from "react-router";
import { useIssueCountQuery } from "features/Issues/hooks";
import { IssueType } from "models/issue";

interface GlobalIssuesBannerProps {
  issueTypes: IssueType[];
  title: string;
  description: string;
  linkTo?: string;
}

function GlobalIssuesBanner({
  issueTypes,
  title,
  description,
  linkTo,
}: GlobalIssuesBannerProps) {
  const { data: issueCountData } = useIssueCountQuery(issueTypes);
  const [isDismissed, setIsDismissed] = useState(false);
  const navigate = useNavigate();

  const issueCount = issueCountData?.count || 0;
  const alertTextColor = useColorModeValue("fg.subtle", "inherit");

  const shouldShow = issueCount > 0 && !isDismissed;

  if (!shouldShow) return null;

  const handleClick = () => {
    navigate(linkTo ?? "/people-team/issues");
  };

  return (
    <Alert
      status="warning"
      cursor="pointer"
      onClick={handleClick}
      transition="background-color 0.2s"
      position="relative"
    >
      <AlertIcon />
      <Box flex="1">
        <AlertTitle color={alertTextColor}>
          {issueCount > 1 ? `${issueCount} ` : ""}
          {title}
        </AlertTitle>
        <AlertDescription color={alertTextColor} fontSize="sm">
          {description}
        </AlertDescription>
      </Box>
      <CloseButton
        position="absolute"
        right="8px"
        top="8px"
        onClick={(e) => {
          e.stopPropagation();
          setIsDismissed(true);
        }}
      />
    </Alert>
  );
}

export function MissingChannelMembershipBanner() {
  return (
    <GlobalIssuesBanner
      issueTypes={["missing_channel_membership"]}
      title="Missing Slack Channel Membership"
      description="Camino is not added to the slack channel. Click to resolve."
    />
  );
}

export default GlobalIssuesBanner;
